import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import TextForm from "../types/TextForm";

export const ProductYearForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    mask: "9999",
    placeholder: "YYYY",
    format: "YYYY",
    min: 1970,
    max: new Date().getFullYear(),
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.ProductYear}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <TextForm
        node={node}
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
